import React, { useState } from "react";
import { Box, Container } from "@mui/material";
import {
  setTabSelectionsEndpoints,
  selectTabSelectionsEndpoints,
} from "@/features/connections/integrationSlice";
import EndpointGrid from "./EndpointGrid";
import { useDispatch, useSelector } from "react-redux";

import { ShepTab, ShepTabs } from "@/components/GenericComponents/ShepTab";
const EndpointHome = () => {
  const dispatch = useDispatch();
  const tabValue = useSelector(selectTabSelectionsEndpoints);
  const setTabValue = (value) => dispatch(setTabSelectionsEndpoints(value));
  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
  };

  return (
    <Container>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          marginBottom: "40px",
          width: "100%",
          backgroundColor: "var(--default-light)",
        }}
      >
        <ShepTabs
          variant="tertiary"
          value={tabValue}
          onChange={handleTabChange}
          aria-label="workflow tabs"
        >
          {/* <ShepTab
          variant="tertiary"
          key="1"
          label={"Summary"}
          iconPosition="start"
        /> */}
          <ShepTab
            variant="tertiary"
            key="2"
            label={"Manager"}
            iconPosition="start"
          />
        </ShepTabs>
      </div>
      <Box>
        {/* {tabValue === 0 && <Box>Endpoints Summary</Box>} */}
        {tabValue === 0 && <EndpointGrid />}
      </Box>
    </Container>
  );
};
export default EndpointHome;
